export default __webpack_public_path__ + "static/7-99302a97f0c49cc440f8eb4b271c63d0.webp";